/**
 * useAuthContext - hook to access auth state from AuthProvider.
 * Separated from AuthProvider.tsx to comply with react-refresh rules.
 */

import { useContext } from 'react'
import { AuthContext } from './auth-context.js'
import type { UseAuthReturn } from './useAuth.js'

export function useAuthContext(): UseAuthReturn {
  const ctx = useContext(AuthContext)
  if (!ctx) {
    throw new Error('useAuthContext must be used within an AuthProvider')
  }
  return ctx
}
